module.exports = __webpack_public_path__ + "_assets/img/binding03.a86845a0.png";